// Orden único de tallas para todo el sistema (PDFs, rejillas, etiquetas).
//   - Numéricas: de menor a mayor (22, 24, ... 50).
//   - De letra: orden natural de ropa (XXCH, XCH, CH, M, G, XG, ... / XS, S, M, L, XL ...).
//   - UNICA / ÚNICA: al final.
//   - Cualquier otra: alfabética, después de las anteriores.
const ORDEN_LETRAS = [
  "XXXCH", "XXCH", "XCH", "CH", "XS", "S", "M", "MED", "G", "L",
  "XG", "XL", "XXG", "XXL", "XXXG", "XXXL", "XXXXG", "XXXXL",
];

const limpia = (t) =>
  String(t == null ? "" : t)
    .trim()
    .toUpperCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");

// Devuelve [grupo, valor] para comparar: 0 = numérica, 1 = letra, 2 = otra, 3 = única/vacía
function rango(talla) {
  const t = limpia(talla);
  if (!t || t === "UNICA" || t === "UNICO" || t === "U") return [3, 0];
  const num = t.replace(",", ".").match(/^\d+(\.\d+)?$/);
  if (num) return [0, parseFloat(t.replace(",", "."))];
  const iLetra = ORDEN_LETRAS.indexOf(t);
  if (iLetra >= 0) return [1, iLetra];
  return [2, t];
}

// Comparador por NOMBRE de talla (para .sort)
export function compararTallas(a, b) {
  const [ga, va] = rango(a);
  const [gb, vb] = rango(b);
  if (ga !== gb) return ga - gb;
  if (typeof va === "number" && typeof vb === "number") return va - vb;
  return String(va).localeCompare(String(vb));
}

// Ordena una lista de objetos-talla ({ name }) o de nombres
export function ordenarTallas(lista, getNombre = (x) => (x && x.name != null ? x.name : x)) {
  return [...(lista || [])].sort((a, b) => compararTallas(getNombre(a), getNombre(b)));
}

// Ordena los renglones de un PDF por talla ascendente SIN mover el orden de los grupos:
// los grupos (p. ej. artículo + color) se quedan en el orden en que aparecen por primera
// vez, y dentro de cada grupo los renglones van de la talla menor a la mayor.
export function ordenarRenglonesPorTalla(renglones, getTalla, getGrupo = () => "") {
  const primeraVez = new Map();
  (renglones || []).forEach((r, i) => {
    const g = getGrupo(r);
    if (!primeraVez.has(g)) primeraVez.set(g, i);
  });
  return (renglones || [])
    .map((r, i) => ({ r, i }))
    .sort((x, y) => {
      const gx = primeraVez.get(getGrupo(x.r));
      const gy = primeraVez.get(getGrupo(y.r));
      if (gx !== gy) return gx - gy;
      const c = compararTallas(getTalla(x.r), getTalla(y.r));
      return c !== 0 ? c : x.i - y.i; // estable
    })
    .map((x) => x.r);
}

// Orden "talla primero y luego color" (regla para todo el sistema):
//   1) artículo/partida, en el orden en que aparecen,
//   2) talla ascendente (34, 36 ... UNICA),
//   3) color, en el orden en que aparece por primera vez.
// Ej.: 34 NEGRO, 34 OLIVO, 36 NEGRO, 36 OLIVO...
export function ordenarPorTallaYColor(renglones, getTalla, getColor = () => "", getArticulo = () => "") {
  const lista = renglones || [];
  const ordenArt = new Map();
  const ordenColor = new Map();
  lista.forEach((r) => {
    const a = String(getArticulo(r) == null ? "" : getArticulo(r));
    const c = String(getColor(r) == null ? "" : getColor(r));
    if (!ordenArt.has(a)) ordenArt.set(a, ordenArt.size);
    if (!ordenColor.has(c)) ordenColor.set(c, ordenColor.size);
  });
  return lista
    .map((r, i) => ({ r, i }))
    .sort((x, y) => {
      const ax = ordenArt.get(String(getArticulo(x.r) == null ? "" : getArticulo(x.r)));
      const ay = ordenArt.get(String(getArticulo(y.r) == null ? "" : getArticulo(y.r)));
      if (ax !== ay) return ax - ay;
      const t = compararTallas(getTalla(x.r), getTalla(y.r));
      if (t !== 0) return t;
      const cx = ordenColor.get(String(getColor(x.r) == null ? "" : getColor(x.r)));
      const cy = ordenColor.get(String(getColor(y.r) == null ? "" : getColor(y.r)));
      return cx !== cy ? cx - cy : x.i - y.i; // estable
    })
    .map((x) => x.r);
}
